
$(document).ready(function() {

    if ($('table.profiles-table')) {
      $table = $('table.profiles-table');

      var order1Name = -1;
      var order2Name = 1;

      var order1Date = -1;
      var order2Date = 1;

      formatDataDate();

      $('.bttn-dark-sort.on-name').on('click', function () {
        sort('name', order1Name, order2Name);
        order1Name = order1Name * -1;
        order2Name = order2Name * -1;
      });

      $('.bttn-dark-sort.on-date').on('click', function () {
        sort('sort-date', order1Date, order2Date);
        order1Date = order1Date * -1;
        order2Date = order2Date * -1;
      });
    }

    function formatDataDate () {
      $('tr.card').each(function() {
        var dateString = $(this).data('date');
        var dateFull = new Date(dateString.split('/')[2], dateString.split('/')[1] - 1, dateString.split('/')[0]);
        var sortDate = dateFull.getTime();
        $(this).attr('data-sort-date', sortDate);
      });
    }

    function sort(dataVal, order1, order2) {

      var rows = $table.find('tr.card').get();
      rows.sort(function(a, b) {
        var keyA = $(a).data(dataVal);
        var keyB = $(b).data(dataVal);
        if (keyA < keyB) return order1;
        if (keyA > keyB) return order2;
        return 0;
      });
      $.each(rows, function(index, row) {
        $table.children('tbody').append(row);
      });
      var count = 0;
      $('tr.card').each(function() {
        $(this).addClass('fade-out');

        if ((count % 2) != 0) {
            $(this).removeClass('even');
            $(this).addClass('odd');
            count++;
        } else {
            $(this).removeClass('odd');
            $(this).addClass('even');
            count++;
        }
        var _this = $(this)
        setTimeout(function() {
          _this.removeClass('fade-out');
        }, 50*count);
      });
      count = 0;
    }
  });
